<template>
  <div id="allproduct-parent">
    <span id="sideFilter-desktop">
      <sideFilter></sideFilter>
    </span>
    <span id="product-grid-allproduct">
      <productGrid></productGrid>
    </span>
  </div>
</template>

<script>
import productGrid from "../components/productGrid";
import sideFilter from "../components/sideFilter";

export default {
  components: {
    productGrid,
    sideFilter
  },
  created() {
    this.$store.state.currentNav = "light";
  }
};
</script>

<style scoped>
#allproduct-parent {
  background-color: white;
  padding-top: 5em;
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 100vh;
}
@media only screen and (min-width: 700px) {
  #sideFilter-desktop {
    width: 20%;
    display: flex;
    justify-content: center;
  }
  #product-grid-allproduct {
    width: 80%;
  }
}
@media only screen and (max-width: 600px) {
  #sideFilter-desktop {
    visibility: hidden;
    position: fixed;
    width: 0;
    height: 0;
  }
  #product-grid-allproduct {
    width: 100%;
  }
}
</style>
